import { toast } from "react-toastify";
import Button from "../../../Components/Button";
import { IAdditional } from "../../TableTemplate/tableTemplate";
import { TableCell } from "@mui/material";
import { packetErrorHandler } from "../../../Utils/requestUtils";
import { useContext, useState } from "react";
import Loading from "../../../Components/Loading/Loading";
import DeleteIcon from "@mui/icons-material/Delete";
import { IProfileTableRow } from "src/Interfaces/deltaHedgeBackTest";
import { deleteProfile } from "src/Requests/deltaHedgeBackTest";
import { Edit } from "@mui/icons-material";
import { Modal } from "src/Components";
import AddProfile from "src/Pages/DeltaHedgeBackTest/AddProfile";
import { RefreshFlagContext } from "src/Pages/DeltaHedgeBackTest";

const TableAdditionalHeader: React.FC = ({}) => {
  return (
    <>
      <TableCell>
        <span className="!font-black text-black">ویرایش</span>
      </TableCell>
      <TableCell>
        <span className="!font-black text-black">حذف</span>
      </TableCell>
    </>
  );
};

const AdditionalCol: React.FC<{
  row: IProfileTableRow;
  onAction: () => void;
}> = ({ row }) => {
  const [loading, setLoading] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  const { setRefreshFlag } = useContext(RefreshFlagContext);

  const deleteHandler = () => {
    setLoading(true);
    deleteProfile(encodeURIComponent(row.profileName))
      .then((resp) => {
        toast.success(resp.msg);
        setRefreshFlag(true);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  return (
    <>
      <TableCell>
        {isEditModalOpen ? (
          <Modal
            title="ویرایش پروفایل"
            onClose={() => setIsEditModalOpen(false)}
            UI={
              <AddProfile
                onClose={() => {
                  setIsEditModalOpen(false);
                  setRefreshFlag(true);
                }}
                editValues={{
                  profileName: row.profileName,
                  searchParam: row.pairPositionSearchParam,
                  timeConfig: row.timeConfig,
                }}
              />
            }
          />
        ) : (
          <></>
        )}
        <div className="w-min mx-auto">
          <Button
            text={<Edit />}
            variant="contained"
            onClick={() => setIsEditModalOpen(true)}
            className="table-btn"
          />
        </div>
      </TableCell>
      <TableCell>
        <div className="w-min mx-auto">
          <Button
            text={
              loading ? (
                <Loading size={16} className="!text-white" />
              ) : (
                <DeleteIcon />
              )
            }
            variant="contained"
            onClick={deleteHandler}
            className="table-btn"
          />
        </div>
      </TableCell>
    </>
  );
};

export const TableAdditional: IAdditional<IProfileTableRow> = {
  getHeader: TableAdditionalHeader,
  getRow: AdditionalCol,
};
